import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles({
  '@global': {},
});

const Globals: React.FC = () => {
  useStyles();
  return null;
};
export default Globals;
